import c from 'classnames';

import styles from './NewUpdateDot.module.css';

export interface NewUpdateDotProps {
  show: boolean;
  className?: string;
  ariaLabel?: string;
}

export const NewUpdateDot = ({
  show,
  className,
  ariaLabel = 'New update available',
}: NewUpdateDotProps) => {
  if (!show) return null;
  return (
    <span
      className={c(styles.dot, className)}
      role='status'
      aria-label={ariaLabel}
    />
  );
};

export default NewUpdateDot;
